import React, { Component } from "react";
import axios from "axios";
import Alert from "react-s-alert";
import SimpleReactLightbox from "simple-react-lightbox";
import { SRLWrapper } from "simple-react-lightbox";
import Image from "react-bootstrap/Image";
import Form from "react-bootstrap/Form";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { TopTextReusableComponent } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  NewInputText,
  SelectBoxMUiInputComponent,
} from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import { FormHelperText, IconButton } from "@material-ui/core";
import {
  ReusableOnboardingButton,
  ReusableOnboardingMapButton,
} from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import InputNumberFunc from "../../../../../function/InputNumberFunc";
import { InputCharacterCheck } from "../../../../../function/InputCharNumCheckFunc";
import { imageUploadSize } from "../../../../../config/Keys";
import SingleImageReusableComponent from "../../../../reusableComponents/imageUploadReusableComponent/SingleImageReusableComponent";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../store/actions/errorActions";
import { point_of_contact_error_check } from "./errorChecker";
import { superadmin_create_and_update_restaurant } from "../../../../../store/actions/SuperAdminActions/adminNewVendorOnboard";
import isEmpty from "../../../../../store/validation/is-Empty";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";
import { DropDownBoxCrret } from "../../../../reusableComponents/dropDownButtonReusable/DropDownButton";
import { AddButtonIconComponent } from "../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";

const validEmailRegex = RegExp(
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
);
// const validateForm = (errors) => {
//   let valid = true;
//   Object.values(errors).forEach((val) => val.length > 0 && (valid = false));
//   return valid;
// };

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

const revenueData = [
  { id: 1, name: "Accounting / Finance", value: "Accounting / Finance" },
  { id: 2, name: "Assistant Manager", value: "Assistant Manager" },
  { id: 3, name: "Back Office", value: "Back Office" },
  { id: 4, name: "Chef", value: "Chef" },
  { id: 5, name: "Delivery", value: "Delivery" },
  { id: 6, name: "Front Office", value: "Front Office" },
  { id: 7, name: "General Manager", value: "General Manager" },
  { id: 8, name: "Hostess. / Host", value: "Hostess. / Host" },
  { id: 9, name: "Manager", value: "Manager" },
  { id: 10, name: "Owner", value: "Owner" },
  { id: 11, name: "Other", value: "Other" },
  { id: 12, name: "Proprietor", value: "Proprietor" },
  { id: 13, name: "Receptionist", value: "Receptionist" },
  { id: 14, name: "Sue-Chef", value: "Sue-Chef" },
  { id: 15, name: "Waiter", value: "Waiter" },
];

export class SuperAdminAddPointOfContact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vendor_id: "",
      dropDownBox: false,
      selectedPositionError: false,
      actionButton: false,
      loader: false,
      selectedTab: 1,
      onPositionModel: false,
      firstName: "",
      lastName: "",
      selected_position: "",
      position: "",
      country_code: "",
      enquiry_emails: [""],
      emailError: "",
      phone_numbers: [{ country_code: "", mobile_no: "" }],
      phoneError: "",
      profile_Photo: "",
      defaultChecked: false,
      contacts_array: [],
      editKey: "",
      errors: {},
      error: null,
      isLoading: false,
    };
  }

  componentDidMount() {
    let onboarding = this.props?.editDataAction
      ? this.props?.editData
      : this.props?.onboardingData;
    let adminVendorId = this.props?.editDataAction
      ? this.props?.editData?.vendor_id
      : JSON.parse(localStorage.getItem("vendorId"));
    const formData = {
      vendor_id: adminVendorId,
    };
    if (adminVendorId !== null || adminVendorId !== undefined) {
      this.props.superadmin_create_and_update_restaurant(formData);
      this.setState({
        vendor_id: formData.vendor_id,
      });
    }
    if (this.props?.auth?.loader) {
      this.setState({
        loader: this.props?.auth?.loader,
      });
    }
    this.setState({ isLoading: true });
    axios
      .get("https://ipapi.co/json")
      .then((result) =>
        this.setState({
          country_code: result.data.country_calling_code,
          isLoading: false,
        })
      )
      .catch((error) =>
        this.setState({
          error,
          isLoading: false,
        })
      );
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    let onboarding = nextProps?.editDataAction
      ? nextProps?.editData
      : nextProps?.onboardingData;
    if (!isEmpty(onboarding?.point_of_contact) && !nextState.hasSetMapProps) {
      const contacts_array = JSON.parse(
        JSON.stringify(onboarding?.point_of_contact)
      );
      let to_be_set = contacts_array[contacts_array.length - 1];
      let to_be_displayed = contacts_array;
      to_be_displayed.splice(contacts_array.length - 1, 1);
      if (onboarding?.point_of_contact.length > 0) {
        return {
          ...nextState,
          contacts_array: to_be_displayed,
          hasSetMapProps: true,
          ...to_be_set,
        };
      }
    }
    if (nextProps?.auth?.loader !== nextState?.loader) {
      return {
        loader: nextProps?.auth?.loader,
      };
    }
    if (nextProps?.errors !== nextState?.errors) {
      return {
        errors: nextProps?.errors,
      };
    }
    return null;
  }

  /**************************************
   * @DESC Positon Role Model
   *************************************/
  onPositionModel = () => {
    this.setState({
      selectedPositionError: true,
      onPositionModel: true,
    });
  };

  onPositionCloseModel = () => {
    this.setState({
      selectedPositionError: true,
      onPositionModel: false,
    });
  };

  onPositionButtonClick = (e, type) => {
    e.preventDefault();
    this.setState({
      selected_position: type,
      onPositionModel: false,
      selectedPositionError: false,
    });
  };

  onChange = (e) => {
    this.props.clear_all_errors();
    // this.setState({
    //   [e.target.name]: e.target.value,
    //   actionButton: true,
    // });
    let data = e.target.value.split(" ");
    let newarray1 = [];
    for (let x = 0; x < data.length; x++) {
      newarray1.push(data[x].charAt(0).toUpperCase() + data[x].slice(1));
    }
    let newData = newarray1.join(" ");
    this.setState({
      [e.target.name]: newData,
      actionButton: true,
    });
  };

  onPrimaryButtonChange = (index) => (e) => {
    let { contacts_array } = this.state;
    contacts_array.forEach((contact) => (contact.defaultChecked = false));
    contacts_array[index].defaultChecked =
      !contacts_array[index].defaultChecked;
    this.setState({
      contacts_array: contacts_array,
      actionButton: true,
    });
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[
        e.target.name
      ] = `*Fields can’t be blank. Please enter your ${e.target.name}`;
    } else {
      delete errors[e.target.name];
    }
    this.setState({
      errors: errors,
      error: Object.keys(errors).length > 0 ? true : false,
      actionButton: true,
    });
  };

  /*****************************************
   * @DESC - Add Handlers
   ******************************************/
  onAddMoreContactHandler = (e) => {
    // e.preventDefault();
    const {
      firstName,
      lastName,
      position,
      selected_position,
      enquiry_emails,
      phone_numbers,
      contacts_array,
    } = this.state;
    if (
      firstName === "" ||
      lastName === "" ||
      selected_position === "" ||
      // (selected_position === "Other" ? position === "" : null) ||
      enquiry_emails[enquiry_emails.length - 1] === "" ||
      phone_numbers[phone_numbers.length - 1].mobile_no === ""
    ) {
      const { errors } = this.state;
      errors.selected_position = "Position is required";
      this.setState({
        errors: errors,
      });
    } else if (selected_position === "Other" && position === "") {
      const { errors } = this.state;
      errors.position = "Position description is required";
      this.setState({
        errors: errors,
      });
    }
    // else if (profile_Photo === "") {
    //   alert("Profile photo is required");
    // }
    else {
      if (contacts_array.length === 0) {
        let contactData = {
          id: 1,
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          selected_position: this.state.selected_position,
          position: this.state.position,
          phone_numbers: this.state.phone_numbers,
          enquiry_emails: this.state.enquiry_emails,
          // defaultChecked: this.state.defaultChecked,
          defaultChecked: true,
          profile_Photo: this.state.profile_Photo,
        };
        contacts_array.push(contactData);
        this.setState({
          contacts_array: contacts_array,
          firstName: "",
          lastName: "",
          selected_position: "",
          position: "",
          enquiry_emails: [""],
          phone_numbers: [{ country_code: "", mobile_no: "" }],
          defaultChecked: false,
          profile_Photo: "",
        });
      } else {
        let id = contacts_array[contacts_array.length - 1].id;
        let contactData = {
          id: id + 1,
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          selected_position: this.state.selected_position,
          position: this.state.position,
          phone_numbers: this.state.phone_numbers,
          enquiry_emails: this.state.enquiry_emails,
          defaultChecked: this.state.defaultChecked,
          profile_Photo: this.state.profile_Photo,
        };
        contacts_array.push(contactData);
        this.setState({
          contacts_array: contacts_array,
          firstName: "",
          lastName: "",
          selected_position: "",
          position: "",
          enquiry_emails: [""],
          phone_numbers: [{ country_code: "", mobile_no: "" }],
          defaultChecked: false,
          profile_Photo: "",
        });
      }
    }
  };

  /*****************************************
   * @DESC - Multiple Email Handlers
   ******************************************/
  onEmailAddHandler = (e) => {
    e.preventDefault();
    let enquiry_emails = this.state.enquiry_emails;
    if (enquiry_emails.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      enquiry_emails[enquiry_emails.length - 1] === "" ||
      !validEmailRegex.test(enquiry_emails[enquiry_emails.length - 1])
    ) {
      const { errors } = this.state;
      if (e.target.value === "") {
        errors.enquiry_emails = `email is required`;
      } else {
        delete errors[e.target.name];
        this.setState({ errors: {} });
      }
      this.setState({
        errors: errors,
      });
      // const { errors, isValid } = RestaurantPointOfContact(this.state);
      // if (!isValid) {
      //   this.setState({
      //     emailError: errors,
      //   });
      // }
    } else {
      enquiry_emails.push("");
      this.setState({
        enquiry_emails: enquiry_emails,
      });
    }
  };

  onEmailChangeHandler = (index) => (e) => {
    let enquiry_emails = this.state.enquiry_emails;
    if (enquiry_emails.includes(e.target.value)) {
      alert("Email Already Exits");
    } else {
      enquiry_emails[index] = e.target.value;
      this.setState({
        enquiry_emails: enquiry_emails,
        emailError: "",
        actionButton: true,
      });
    }
  };

  onEmailDeleteHandler = (index) => (e) => {
    e.preventDefault();
    let enquiry_emails = this.state.enquiry_emails;
    if (enquiry_emails.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      enquiry_emails.splice(index, 1);
      this.setState({ enquiry_emails: enquiry_emails });
    }
  };

  /*****************************************
   * @DESC - Multiple Phone Handlers
   ******************************************/
  onPhondeAddHandler = (e) => {
    e.preventDefault();
    let phone_numbers = this.state.phone_numbers;
    if (phone_numbers.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      phone_numbers[phone_numbers.length - 1].mobile_no === "" ||
      phone_numbers[phone_numbers.length - 1].mobile_no <= 9
    ) {
      // const { errors, isValid } = RestaurantPointOfContact(this.state);
      // if (!isValid) {
      //   this.setState({
      //     phoneError: errors,
      //   });
      // }phone number is required
      const { errors } = this.state;
      if (e.target.value === "") {
        errors.mobile_no = `phone number is required`;
      } else {
        delete errors[e.target.name];
        this.setState({ errors: {} });
      }
      this.setState({
        errors: errors,
      });
    } else {
      phone_numbers.push({
        country_code: this.state.country_code,
        mobile_no: "",
      });
      this.setState({
        phone_numbers: phone_numbers,
      });
    }
  };

  onPhoneChangeHandler = (index) => (e) => {
    let phone_numbers = this.state.phone_numbers;
    if (phone_numbers.some((diner) => diner.mobile_no === e.target.value)) {
      alert("Phone Number Already Exits");
    } else {
      phone_numbers[index].country_code =
        phone_numbers[index].country_code === ""
          ? this.state.country_code
          : phone_numbers[index].country_code;
      phone_numbers[index].mobile_no = e.target.value.slice(
        0,
        e.target.maxLength
      );
      this.setState({
        phone_numbers: phone_numbers,
        phoneError: "",
        actionButton: true,
      });
    }
  };

  onCountryCodeChangeHandler = (index) => (e) => {
    let phone_numbers = this.state.phone_numbers;
    phone_numbers[index].country_code = e.target.value;
    this.setState({
      phone_numbers: phone_numbers,
      phoneError: "",
      actionButton: true,
    });
  };

  onPhoneDeleteHandler = (index) => (e) => {
    e.preventDefault();
    let phone_numbers = this.state.phone_numbers;
    if (phone_numbers.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      phone_numbers.splice(index, 1);
      this.setState({ phone_numbers: phone_numbers });
    }
  };

  /**************************************
   * @DESC - ON IMAGE UPLOAD HANDLER
   * @DESC - USER DEFINED METHODS
   **************************************/

  onCompleteCrop = (url) => {
    this.setState({
      profile_Photo: url,
      logo_main: null,
      singleImageLoader: false,
      actionButton: true,
    });
  };

  onCancelCrop = () => {
    this.setState({ logo_main: null });
  };

  onImageLogoUploadHandler = (e) => {
    // this.setState({ singleImageLoader: true });
    // console.log(e.target.files[0]);
    let onboarding = this.props?.editDataAction
      ? this.props?.editData
      : this.props?.onboardingData;
    if (e.target.files) {
      const vendor_id = this.state.vendor_id;
      const restaurant_name = onboarding?.restaurant_name.split(" ").join("");
      const combined = vendor_id + "_" + restaurant_name;
      const data = new FormData();
      data.append("files", e.target.files[0]);
      if (e.target.files[0].size > imageUploadSize) {
        alert("File is too Big");
      } else {
        this.setState({
          logo_main: e.target.files[0],
          combined: combined,
        });
      }
    }
    e.target.value = "";
  };

  removeFile = (e) => {
    let restaurantLogo = this.state.profile_Photo;
    restaurantLogo = "";
    this.setState({
      profile_Photo: restaurantLogo,
      actionButton: true,
    });
  };

  /******************************
   * ONEDIT BUTTON HANDLER
   ******************************/
  onEditButtonCLickHandler = (id) => (e) => {
    let contacts_array = this.state.contacts_array;
    let phoneObj = contacts_array.find((phone) => phone.id === id);
    let indexOf = contacts_array.indexOf(phoneObj);
    let contactData = {
      id: contacts_array.length + 1,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      selected_position: this.state.selected_position,
      position: this.state.position,
      phone_numbers: this.state.phone_numbers,
      enquiry_emails: this.state.enquiry_emails,
      defaultChecked: this.state.defaultChecked,
      profile_Photo: this.state.profile_Photo,
    };
    let to_be_set = contacts_array[indexOf];
    contacts_array.splice(indexOf, 1);
    contacts_array.push(contactData);
    this.setState({
      editKey: id,
      // firstName: contacts_array[indexOf].firstName,
      // lastName: contacts_array[indexOf].lastName,
      // selected_position: contacts_array[indexOf].selected_position,
      // position: contacts_array[indexOf].position,
      // enquiry_emails: contacts_array[indexOf].enquiry_emails,
      // phone_numbers: contacts_array[indexOf].phone_numbers,
      contacts_array: contacts_array,
      ...to_be_set,
    });
  };
  /******************************
   * ONEDIT SAVE HANDLER
   ******************************/
  onEditSaveHandler = (e) => {
    e.preventDefault();
    let contacts_array = this.state.contacts_array;
    let contactData = {
      id: contacts_array.length + 1,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      selected_position: this.state.selected_position,
      position: this.state.position,
      phone_numbers: this.state.phone_numbers,
      enquiry_emails: this.state.enquiry_emails,
      defaultChecked: this.state.defaultChecked,
      profile_Photo: this.state.profile_Photo,
    };

    let to_be_set = contacts_array[contacts_array.length - 1];
    let to_be_displayed = contacts_array;
    to_be_displayed.splice(contacts_array.length - 1, 1);
    to_be_displayed.push(contactData);

    this.setState({
      contacts_array: contacts_array,
      editKey: "",
      ...to_be_set,
    });
  };
  // onEditSaveHandlerNew = (e) => {
  //   e.preventDefault();
  //   this.setState({
  //     editKey: "",
  //   });
  // };

  /******************************
   * ONCLICK DELETE HANDLER
   ******************************/
  onClickContactDelete = (id) => (e) => {
    e.preventDefault();
    let contacts_array = this.state.contacts_array;
    let emailObj = contacts_array.find((email) => email.id === id);
    if (emailObj === 0 || emailObj) {
      contacts_array.splice(contacts_array.indexOf(emailObj), 1);
      this.setState({ contacts_array: contacts_array });
    }
  };

  onBackButton = (history) => (e) => {
    e.preventDefault();
    const sendData = {
      data: true,
      actionButton: 1,
    };
    history.push({
      pathname: this.props?.editDataAction
        ? "/admin_edit_business_details"
        : "/addvendorbusinessdetails",
      state: { formData: sendData },
    });
  };

  withOutApiCall = (e) => {
    this.props.history.push({
      pathname: this.props?.editDataAction
        ? "/admin_edit_restauran_info"
        : "/addvendorrestauraninfo",
    });
  };

  /************************************
   * @DESC Drop Down Box Handler
   ***********************************/
  dropDownBoxClick = (e) => {
    e.preventDefault();
    this.setState({
      dropDownBox: !this.state.dropDownBox,
    });
  };

  handleSubmit = (e) => {
    let onboarding = this.props?.editDataAction
      ? this.props?.editData
      : this.props?.onboardingData;
    e.preventDefault();
    if (this.state.firstName && this.state.lastName) {
      this.onAddMoreContactHandler();
    }
    if (onboarding && onboarding?.point_of_contact.length > 0) {
      let formData = {
        vendor_id: this.state.vendor_id,
        id: onboarding?._id,
        point_of_contact: this.state.contacts_array,
      };
      this.props.superadmin_create_and_update_restaurant(formData);
      this.props.history.push(
        this.props?.editDataAction
          ? "/admin_edit_restauran_info"
          : "/addvendorrestauraninfo"
      );
    } else {
      let formData = {
        vendor_id: this.state.vendor_id,
        id: onboarding?._id,
        point_of_contact: this.state.contacts_array,
        page_completed_till: 3,
      };
      this.props.superadmin_create_and_update_restaurant(formData);
      this.props.history.push(
        this.props?.editDataAction
          ? "/admin_edit_restauran_info"
          : "/addvendorrestauraninfo"
      );
    }
  };

  render() {
    if (this.state.loader) {
      return (
        <React.Fragment>
          <AmealioLoader />
        </React.Fragment>
      );
    }
    const {
      dropDownBox,
      actionButton,
      errors,
      firstName,
      lastName,
      selected_position,
      // position,
      contacts_array,
      enquiry_emails,
      phone_numbers,
      error,
    } = this.state;
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel ">
              <HomeReusableTopBarNavigation />
              <div className="col-12 pl-5 pr-5">
                <div className="super_admin_add_vendor mb-4">
                  <h5 className="main_header_text">
                    {this.props?.editDataAction ? "Edit" : "Add"} Vendor
                  </h5>
                  <h4 className="font_20_m">Step : 3</h4>
                  <h4 className="font_20_m c_red mt-2 mb-1">
                    Point Of Contact
                  </h4>
                  <hr className="hr_line" />
                </div>
                <TopTextReusableComponent
                  headingText="Point of Contact"
                  headingParagraph="Enter the information for the Location Manager and Other Point of Contacts"
                />
                <Form noValidate onSubmit={this.handleSubmit}>
                  <div className="col-6 point_of_contact_onboarding_main onboarding_process_screen-left-mapinside pl-0 pr-0">
                    <div className="row">
                      <div className="col-6">
                        <NewInputText
                          extraClass="mt-4"
                          name="firstName"
                          inputType="text"
                          onChange={this.onChange}
                          onFocusOut={this.onFocusOut}
                          onKeyDown={InputCharacterCheck}
                          value={this.state.firstName}
                          maxLength={35}
                          errorText={
                            errors.firstName ===
                            "*Fields can’t be blank. Please enter your firstName"
                              ? "*Fields can’t be blank. Please enter your first Name"
                              : null
                          }
                          errorTrue={
                            errors.firstName ===
                            "*Fields can’t be blank. Please enter your firstName"
                              ? true
                              : false
                          }
                          labelText="First Name*"
                          controlClass={
                            errors.firstName ===
                            "*Fields can’t be blank. Please enter your firstName"
                              ? "outlined-error-helper-text"
                              : "outlined-helperText "
                          }
                        />
                      </div>
                      <div className="col-6">
                        <NewInputText
                          extraClass="mt-4"
                          name="lastName"
                          inputType="text"
                          onChange={this.onChange}
                          onFocusOut={this.onFocusOut}
                          onKeyDown={InputCharacterCheck}
                          value={this.state.lastName}
                          maxLength={35}
                          errorText={
                            errors.lastName ===
                            "*Fields can’t be blank. Please enter your lastName"
                              ? "*Fields can’t be blank. Please enter your last Name"
                              : null
                          }
                          errorTrue={
                            errors.lastName ===
                            "*Fields can’t be blank. Please enter your lastName"
                              ? true
                              : false
                          }
                          labelText="Last Name*"
                          controlClass={
                            errors.lastName ===
                            "*Fields can’t be blank. Please enter your lastName"
                              ? "outlined-error-helper-text"
                              : "outlined-helperText "
                          }
                        />
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <div className="row">
                          <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 ">
                            <div className="position-relative ">
                              {console.log(errors)}
                              <SelectBoxMUiInputComponent
                                extraClass={false}
                                displayNone={true}
                                selectLabel="Position*"
                                name="selected_position"
                                value={this.state.selected_position}
                                onChange={this.onChange}
                                getData={revenueData}
                                errorText={errors.selected_position}
                                errorTrue={
                                  errors.selected_position === "" ? true : false
                                }
                                helperText="Please select your currency"
                              />
                              <FormHelperText
                                id="f9-400 opacity5"
                                className="f9-400 opacity5"
                              >
                                Enter the Position for Point of Contact - this
                                is required info
                              </FormHelperText>
                            </div>
                          </div>
                          <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            {selected_position === "Other" ? (
                              <NewInputText
                                extraClass="mb-0 position-discription-mobile"
                                name="position"
                                inputType="text"
                                onChange={this.onChange}
                                onFocusOut={this.onFocusOut}
                                onKeyDown={InputCharacterCheck}
                                value={this.state.position}
                                errorText={errors.position}
                                errorTrue={
                                  errors.position ===
                                    "*Fields can’t be blank. Please enter your position" ||
                                  errors.position ===
                                    "Position description is required"
                                    ? true
                                    : false
                                }
                                labelText="Description of Position"
                                controlClass={
                                  errors.position ===
                                    "*Fields can’t be blank. Please enter your position" ||
                                  errors.position ===
                                    "Position description is required"
                                    ? "outlined-error-helper-text"
                                    : "outlined-helperText "
                                }
                              />
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                    {this.state.enquiry_emails.map((email, index) => (
                      <div
                        className="row align-items-center mb-4 mt-4"
                        key={index}
                      >
                        <div className="col-9">
                          <NewInputText
                            extraClass="mt-0 mb-0"
                            name="enquiry_emails"
                            inputType="email"
                            onFocusOut={this.onFocusOut}
                            onChange={this.onEmailChangeHandler(index)}
                            value={email}
                            errorText={
                              !validEmailRegex.test(email) && !isEmpty(email)
                                ? "Please enter a valid email"
                                : null ||
                                  (email === "" &&
                                  errors.enquiry_emails === "email is required"
                                    ? "*Fields can’t be blank. Please enter your Email"
                                    : null) ||
                                  (email === "" &&
                                    errors.enquiry_emails ===
                                      "*Fields can’t be blank. Please enter your enquiry_emails")
                                ? "*Fields can’t be blank. Please enter your Email"
                                : ""
                            }
                            errorTrue={
                              (!validEmailRegex.test(email) &&
                                !isEmpty(email)) ||
                              (email === "" &&
                                errors.enquiry_emails ===
                                  "email is required") ||
                              (email === "" &&
                                errors.enquiry_emails ===
                                  "*Fields can’t be blank. Please enter your enquiry_emails")
                                ? true
                                : false
                            }
                            labelText="Enquiry Email*"
                            controlClass={
                              (!validEmailRegex.test(email) &&
                                !isEmpty(email)) ||
                              (email === "" &&
                                errors.enquiry_emails ===
                                  "email is required") ||
                              (email === "" &&
                                errors.enquiry_emails ===
                                  "*Fields can’t be blank. Please enter your enquiry_emails")
                                ? "outlined-error-helper-text"
                                : "outlined-helperText"
                            }
                          />
                        </div>
                        <div className="col-3 restaurant_details_onboarding_minus_button">
                          {this.state.enquiry_emails.length > 1 ? (
                            <div>
                              <AddButtonIconComponent
                                buttonText="Delete"
                                onClick={this.onEmailDeleteHandler(index)}
                                fontIcon="fa fa-trash-o"
                                colorCss="delete"
                              />
                            </div>
                          ) : (
                            <div>
                              <AddButtonIconComponent
                                buttonText="Add Another"
                                onClick={this.onEmailAddHandler}
                                fontIcon="fa fa-plus"
                                colorCss="blue"
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                    {this.state.enquiry_emails.length > 1 ? (
                      <div className="col-12 p-0 mb-4 restaurant_details_onboarding_minus_button add_email_button">
                        <div>
                          <AddButtonIconComponent
                            buttonText="Add Another Email"
                            onClick={this.onEmailAddHandler}
                            fontIcon="fa fa-plus"
                            colorCss="blue"
                          />
                        </div>
                      </div>
                    ) : null}

                    {this.state.phone_numbers.map((phone, index) => (
                      <div className="row  align-items-center mb-4" key={index}>
                        <div className="col-4 col-xl-3">
                          <Form.Group
                            className="reusableInputComponent-main mb-0"
                            controlId={"country_code"}
                          >
                            <div className="input-phone-country-code-reusable w-100">
                              <select
                                className="w-100"
                                name="country_code"
                                value={phone.country_code}
                                onChange={this.onCountryCodeChangeHandler(
                                  index
                                )}
                              >
                                <option
                                  value={
                                    phone.country_code === ""
                                      ? this.state.country_code
                                      : phone.country_code
                                  }
                                >
                                  {phone.country_code === ""
                                    ? this.state.country_code
                                    : phone.country_code}
                                </option>
                                {getCountries().map((country) => (
                                  <option
                                    key={country}
                                    value={"+" + getCountryCallingCode(country)}
                                    onClick={this.onChangeCountry}
                                  >
                                    {en[country]} (+
                                    {getCountryCallingCode(country)})
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Form.Group>
                        </div>
                        <div className="col-5 col-xl-6 pl-0">
                          <NewInputText
                            extraClass="mb-0"
                            name="mobile_no"
                            inputType="number"
                            onFocusOut={this.onFocusOut}
                            onChange={this.onPhoneChangeHandler(index)}
                            value={phone.mobile_no}
                            maxLength="10"
                            onKeyDown={InputNumberFunc}
                            errorText={
                              phone.mobile_no === "" &&
                              errors.mobile_no === "phone number is required"
                                ? "*Fields can’t be blank. Please enter your valid mobile number"
                                : "" ||
                                  (phone.mobile_no === "" &&
                                    errors.mobile_no ===
                                      "*Fields can’t be blank. Please enter your mobile_no")
                                ? "*Fields can’t be blank. Please enter your valid mobile number"
                                : null ||
                                  (phone.mobile_no.length > 0 &&
                                    phone.mobile_no.length <= 9)
                                ? "Enter your valid mobile number"
                                : null
                            }
                            errorTrue={
                              (phone.mobile_no === "" &&
                                errors.mobile_no ===
                                  "phone number is required") ||
                              (phone.mobile_no === "" &&
                                errors.mobile_no ===
                                  "*Fields can’t be blank. Please enter your mobile_no") ||
                              (phone.mobile_no.length > 0 &&
                                phone.mobile_no.length <= 9)
                                ? true
                                : false
                            }
                            labelText="Phone Number*"
                            controlClass={
                              (phone.mobile_no === "" &&
                                errors.mobile_no ===
                                  "phone number is required") ||
                              (phone.mobile_no === "" &&
                                errors.mobile_no ===
                                  "*Fields can’t be blank. Please enter your mobile_no") ||
                              (phone.mobile_no.length > 0 &&
                                phone.mobile_no.length <= 9)
                                ? "outlined-error-helper-text"
                                : "outlined-helperText"
                            }
                          />
                        </div>

                        <div className="col-3 restaurant_details_onboarding_minus_button">
                          {this.state.phone_numbers.length > 1 ? (
                            <div>
                              <AddButtonIconComponent
                                buttonText="Delete"
                                onClick={this.onPhoneDeleteHandler(index)}
                                fontIcon="fa fa-trash-o"
                                colorCss="delete"
                              />
                            </div>
                          ) : (
                            <div>
                              <AddButtonIconComponent
                                buttonText="Add Another"
                                onClick={this.onPhondeAddHandler}
                                fontIcon="fa fa-plus"
                                colorCss="blue"
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                    {this.state.phone_numbers.length > 1 ? (
                      <div className="col-12 p-0 mt-3 restaurant_details_onboarding_minus_button add_email_button">
                        <div>
                          <AddButtonIconComponent
                            buttonText="Add Another Phone Number"
                            onClick={this.onPhondeAddHandler}
                            fontIcon="fa fa-plus"
                            colorCss="blue"
                          />
                        </div>
                      </div>
                    ) : null}
                    <SimpleReactLightbox>
                      <SingleImageReusableComponent
                        title="Add Profile Image"
                        onChange={this.onImageLogoUploadHandler}
                        combined={this.state.combined && this.state.combined}
                        onCompleteCrop={this.onCompleteCrop}
                        onCancelCrop={this.onCancelCrop}
                        file={
                          (this.state.logo_main && this.state.logo_main) ||
                          (this.state.profile_Photo && this.state.profile_Photo)
                        }
                        resetFile={this.removeFile}
                        name="profile_Photo"
                        error={errors.profile_Photo}
                      />
                      <FormHelperText id="outlined-error-helper-text">
                        Only .jpg and .png files. 500kb max file size
                      </FormHelperText>
                    </SimpleReactLightbox>
                    <div className="row">
                      <div className="col-5">
                        {this.state.editKey ? null : (
                          <button
                            className="w-100 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_active_point f14_400_HelveticaNeue justify-content-center"
                            style={{ color: "#EE3A23" }}
                            title="Save"
                            type="button"
                            onClick={this.onAddMoreContactHandler}
                          >
                            Save
                          </button>
                        )}
                        {/* {this.state.editKey ? null : (
                          <ReusableOnboardingMapButton
                            classsection="onboarding_mapbutton_reusable onboarding_mapbutton_reusable_active_point"
                            title="Add Another Point of Contact"
                            onClick={this.onAddMoreContactHandler}
                          />
                        )} */}
                      </div>
                      <div className="col-5">
                        {this.state.editKey ? null : (
                          <button
                            className="w-100 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_active_point f14_400_HelveticaNeue justify-content-center"
                            style={{ color: "#EE3A23" }}
                            title="Save And Add Another"
                            type="button"
                            onClick={this.onAddMoreContactHandler}
                          >
                            Save And Add Another
                          </button>
                        )}
                      </div>
                    </div>
                    <hr />
                    <div className="row ">
                      {this.state.editKey === "" ? (
                        <div className="col-12 map-button-box-main">
                          <DropDownBoxCrret
                            state={dropDownBox}
                            showText="Hide added contacts"
                            hideText="Show added contacts"
                            onClick={this.dropDownBoxClick}
                          />
                          {dropDownBox ? (
                            <div className="onboarding-point-of-contact-table">
                              <div className="row">
                                <div className="col-4">
                                  <h4 className="big_heading_text">
                                    Added Contacts
                                  </h4>
                                </div>
                                <div className="col-8">
                                  <div className="row">
                                    <div className="col-4">
                                      <h4 className="big_heading_text">
                                        Profile Photo
                                      </h4>
                                    </div>
                                    <div className="col-4">
                                      <h4 className="big_heading_text">
                                        Set as default contact
                                      </h4>
                                    </div>
                                    <div className="col-4">
                                      <h4 className="big_heading_text">
                                        Action
                                      </h4>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {this.state.contacts_array.map(
                                (contact, index) => (
                                  <div
                                    className="row point_of_contact_table-div"
                                    key={index}
                                  >
                                    <div className="col-4 pr-0">
                                      {this.state.editKey === "" ? (
                                        <div className="">
                                          <div className="f14-700">
                                            {contact.firstName +
                                              " " +
                                              contact.lastName}{" "}
                                          </div>
                                          <span className="f9-500 opacity5">
                                            {`(
                                      ${contact.selected_position}
                                      ) `}
                                          </span>
                                          {contact.position && (
                                            <span className="f9-500 opacity5">
                                              {`(
                                      ${contact.position}
                                      ) `}
                                            </span>
                                          )}
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                      {this.state.editKey === "" ? (
                                        <div className="mt-2">
                                          {contact.phone_numbers.map(
                                            (phone, index) => (
                                              <p
                                                className="f12-400 opacity5"
                                                key={index}
                                              >
                                                {phone.country_code +
                                                  "-" +
                                                  phone.mobile_no}
                                              </p>
                                            )
                                          )}
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                      {this.state.editKey === "" ? (
                                        <div className="mt-2">
                                          {contact.enquiry_emails.map(
                                            (email, index) => (
                                              <p
                                                className="f12-400 opacity5"
                                                key={index}
                                              >
                                                {email}
                                              </p>
                                            )
                                          )}
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                    <div className="col-8">
                                      <div className="row">
                                        <div className="col-4">
                                          {this.state.editKey === "" ? (
                                            <div className="lightBoxWraper enIMG33 rounded-circle">
                                              {contact.profile_Photo === "" ? (
                                                ""
                                              ) : (
                                                <SimpleReactLightbox>
                                                  <SRLWrapper options={options}>
                                                    <img
                                                      src={
                                                        contact.profile_Photo
                                                      }
                                                      className="img-fluid"
                                                      alt="Profile Photo"
                                                      title="Profile Photo"
                                                    />
                                                  </SRLWrapper>
                                                </SimpleReactLightbox>
                                              )}
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                        <div className="col-4">
                                          {this.state.editKey === "" ? (
                                            <label className="enRadioWithText small">
                                              <input
                                                type="radio"
                                                name="defaultChecked"
                                                checked={
                                                  this.state.contacts_array[
                                                    index
                                                  ].defaultChecked === true
                                                    ? true
                                                    : false
                                                }
                                                onChange={this.onPrimaryButtonChange(
                                                  index
                                                )}
                                              />
                                              <span className="checkmark"></span>
                                            </label>
                                          ) : null}
                                        </div>
                                        <div className="col-4 d-flex">
                                          {this.state.editKey === "" ? (
                                            <IconButton
                                              className="mr-2 p-0"
                                              onClick={this.onEditButtonCLickHandler(
                                                contact.id
                                              )}
                                            >
                                              <Image
                                                src={require("../../../../../assets/images/UserManagement/editBlue.svg")}
                                                alt="add"
                                                title="add"
                                                className="w-20px"
                                              />
                                            </IconButton>
                                          ) : null}

                                          {this.state.editKey === "" ? (
                                            <IconButton
                                              className="p-0"
                                              onClick={this.onClickContactDelete(
                                                contact.id
                                              )}
                                            >
                                              <Image
                                                src={require("../../../../../assets/images/UserManagement/delete-gray.svg")}
                                                alt="add"
                                                title="add"
                                                className="w-20px"
                                              />
                                            </IconButton>
                                          ) : null}
                                        </div>
                                      </div>
                                    </div>
                                    {this.state.editKey === "" ? (
                                      <div className="col-12">
                                        <hr />
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                )
                              )}
                            </div>
                          ) : null}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="onboarding-map-setup-screen-autodetect-button">
                      {this.state.editKey ? (
                        <ReusableOnboardingButton
                          buttonTitle="Back Button"
                          buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                          buttonText="Back"
                          buttonType="button"
                          // link="/restaurantsettings"
                          onClick={this.onEditSaveHandler}
                        />
                      ) : (
                        <ReusableOnboardingButton
                          buttonTitle="Back Button"
                          buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                          buttonText="Back"
                          buttonType="button"
                          onClick={this.onBackButton(this.props.history)}
                        />
                      )}
                      {contacts_array.length <= 0 ? (
                        <div>
                          <ReusableOnboardingButton
                            buttonTitle="Next Button"
                            buttonClass={
                              firstName === "" ||
                              lastName === "" ||
                              // selected_position === "" ||
                              // profile_Photo === "" ||
                              // (selected_position === "Other" &&
                              //   position === "") ||
                              enquiry_emails[enquiry_emails.length - 1] ===
                                "" ||
                              phone_numbers[phone_numbers.length - 1]
                                .mobile_no === "" ||
                              phone_numbers[phone_numbers.length - 1].mobile_no
                                .length <= 9 ||
                              !validEmailRegex.test(
                                enquiry_emails[enquiry_emails.length - 1]
                              )
                                ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                                : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                            }
                            disabled={
                              firstName === "" ||
                              lastName === "" ||
                              // selected_position === "" ||
                              // profile_Photo === "" ||
                              // (selected_position === "Other" &&
                              //   position === "") ||
                              enquiry_emails[enquiry_emails.length - 1] ===
                                "" ||
                              phone_numbers[phone_numbers.length - 1]
                                .mobile_no === "" ||
                              phone_numbers[phone_numbers.length - 1].mobile_no
                                .length <= 9 ||
                              !validEmailRegex.test(
                                enquiry_emails[enquiry_emails.length - 1]
                              ) ||
                              error
                                ? true
                                : false
                            }
                            buttonText="Next"
                            onClick={
                              actionButton === false
                                ? this.withOutApiCall
                                : null
                            }
                            buttonType={
                              actionButton === false ? "button" : "submit"
                            }
                          />
                        </div>
                      ) : (
                        <div>
                          {this.state.editKey ? (
                            <ReusableOnboardingButton
                              buttonTitle="Save Button"
                              buttonClass={
                                firstName === "" ||
                                lastName === "" ||
                                // selected_position === "" ||
                                // profile_Photo === "" ||
                                // (selected_position === "Other" &&
                                //   position === "") ||
                                enquiry_emails[enquiry_emails.length - 1] ===
                                  "" ||
                                phone_numbers[phone_numbers.length - 1]
                                  .mobile_no === "" ||
                                phone_numbers[phone_numbers.length - 1]
                                  .mobile_no.length <= 9 ||
                                !validEmailRegex.test(
                                  enquiry_emails[enquiry_emails.length - 1]
                                ) ||
                                error
                                  ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                                  : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                              }
                              disabled={
                                firstName === "" ||
                                lastName === "" ||
                                // selected_position === "" ||
                                // profile_Photo === "" ||
                                // (selected_position === "Other"
                                //   ? position === ""
                                //   : null) ||
                                enquiry_emails[enquiry_emails.length - 1] ===
                                  "" ||
                                phone_numbers[phone_numbers.length - 1]
                                  .mobile_no === "" ||
                                phone_numbers[phone_numbers.length - 1]
                                  .mobile_no.length <= 9 ||
                                !validEmailRegex.test(
                                  enquiry_emails[enquiry_emails.length - 1]
                                ) ||
                                error
                                  ? true
                                  : false
                              }
                              buttonText="Save"
                              buttonType="button"
                              onClick={this.onEditSaveHandler}
                            />
                          ) : (
                            <ReusableOnboardingButton
                              buttonTitle="Next three Button"
                              buttonClass={`onboarding_button_link_reusable ${
                                point_of_contact_error_check(this.state, error)
                                  ? "onboarding_button_link_reusable_gray ml-3"
                                  : "onboarding_button_link_reusable_red ml-3"
                              }`}
                              disabled={
                                point_of_contact_error_check(this.state, error)
                                  ? true
                                  : false
                              }
                              buttonText="Next"
                              onClick={
                                actionButton === false
                                  ? this.withOutApiCall
                                  : null
                              }
                              buttonType={
                                actionButton === false ? "button" : "submit"
                              }
                            />
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

SuperAdminAddPointOfContact.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  storage: state.storage,
  onboardingData: state.superAdminOnboarding.restaurantDetails,
  editData: state?.adminAllVendorsInfo?.superAdminMerchantEditInfo,
  editDataAction:
    state?.adminAllVendorsInfo?.superAdminMerchantEditType?.editData,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  superadmin_create_and_update_restaurant,
})(withRouter(SuperAdminAddPointOfContact));
//10-08-20
